export default function Banner() {
  return (
    <>
      <p className="flex h-10 items-center justify-center bg-primary-content px-4 text-sm font-medium text-gray-600 sm:px-6 lg:px-8 mb-0">
        Inspirez votre intérieur avec élégance.
      </p>
    </>
  )
}
